import { render, staticRenderFns } from "./DropdownFieldComponent.vue?vue&type=template&id=58b13128&"
import script from "./DropdownFieldComponent.vue?vue&type=script&lang=js&"
export * from "./DropdownFieldComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports